import { render } from "./NewCuentaEcp.vue?vue&type=template&id=42a67a68&scoped=true"
import script from "./NewCuentaEcp.vue?vue&type=script&lang=js"
export * from "./NewCuentaEcp.vue?vue&type=script&lang=js"

import "../main.css?vue&type=style&index=0&lang=css&external"
import "./NewCuentaEcp.vue?vue&type=style&index=1&id=42a67a68&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42a67a68"]])

export default __exports__